(function () {
  var mq = window.matchMedia("(max-width: 767.98px)");
  var grid = document.querySelector("[data-col-carousel]");
  if (!grid) return;
  var stage = grid.closest(".qurtens-col-stage") || grid.parentElement;
  var root = stage.parentElement || stage;
  var dotsWrap = root.querySelector(".qurtens-col-dots");
  var arrowsWrap = stage.querySelector(".qurtens-col-arrows");
  var prevBtn = arrowsWrap && arrowsWrap.querySelector(".qurtens-col-arrow--prev");
  var nextBtn = arrowsWrap && arrowsWrap.querySelector(".qurtens-col-arrow--next");
  var items = Array.prototype.slice.call(grid.querySelectorAll(".qurtens-col-item"));
  if (items.length < 2) return;

  var dots = [];
  var ticking = false;
  var arrowsBound = false;
  var active = false;

  function indexFromScroll() {
    var w = grid.clientWidth || 1;
    return Math.max(0, Math.min(items.length - 1, Math.round(grid.scrollLeft / w)));
  }

  function syncDots() {
    var idx = indexFromScroll();
    dots.forEach(function (dot, i) {
      dot.classList.toggle("is-active", i === idx);
      dot.setAttribute("aria-current", i === idx ? "true" : "false");
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      syncDots();
    });
  }

  function goTo(i) {
    var next = (i + items.length) % items.length;
    grid.scrollTo({ left: next * grid.clientWidth, behavior: "smooth" });
  }

  function onPrev(e) {
    e.preventDefault();
    goTo(indexFromScroll() - 1);
  }

  function onNext(e) {
    e.preventDefault();
    goTo(indexFromScroll() + 1);
  }

  function setup() {
    if (active) return;
    active = true;
    if (!dots.length && dotsWrap) {
      dotsWrap.hidden = false;
      items.forEach(function (_, i) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.setAttribute("aria-label", "Collection " + (i + 1));
        btn.addEventListener("click", function () {
          goTo(i);
        });
        dotsWrap.appendChild(btn);
        dots.push(btn);
      });
    }
    if (arrowsWrap) {
      arrowsWrap.hidden = false;
      if (!arrowsBound && prevBtn && nextBtn) {
        prevBtn.addEventListener("click", onPrev);
        nextBtn.addEventListener("click", onNext);
        arrowsBound = true;
      }
    }
    grid.addEventListener("scroll", onScroll, { passive: true });
    syncDots();
  }

  function teardown() {
    if (!active) return;
    active = false;
    grid.removeEventListener("scroll", onScroll);
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      dotsWrap.hidden = true;
    }
    dots = [];
    if (arrowsWrap) arrowsWrap.hidden = true;
    if (arrowsBound && prevBtn && nextBtn) {
      prevBtn.removeEventListener("click", onPrev);
      nextBtn.removeEventListener("click", onNext);
      arrowsBound = false;
    }
    grid.scrollLeft = 0;
  }

  function apply() {
    if (mq.matches) setup();
    else teardown();
  }

  apply();
  if (mq.addEventListener) mq.addEventListener("change", apply);
  else mq.addListener(apply);
})();
